module.exports = __webpack_public_path__ + "img/NBTC.7ba163b0.jpg";